export const terms = {
  title: 'EachTeach 利用規約',
  notice: '※本書は、日本語を正文(正式かつ法的に優先される文書)とし、英語・韓国語は参考訳とします。解釈に差異が生じた場合、日本語版が優先されます。',
  
  article1: {
    title: '第1条(定義)',
    intro: '本規約において、以下の用語は次の意味を有します。',
    operator: {
      term: '「運営」:',
      definition: 'EachTeachの企画・管理・運営を行う者'
    },
    service: {
      term: '「本サービス」:',
      definition: '運営が提供するオンライン言語交換・学習支援サービス'
    },
    user: {
      term: '「利用者」:',
      definition: '本規約に同意のうえ本サービスを利用するすべての者'
    },
    session: {
      term: '「セッション」:',
      definition: '運営が指定する方法で行われる言語交換・学習時間(原則90分)'
    }
  },
  
  article2: {
    title: '第2条(サービス内容)',
    point1: '本サービスは、利用者の語学レベル、学習目的等を基に、運営が参加者をマッチングし、オンラインでセッションを提供するものです。',
    point2: 'セッションは、運営が提供または指定するワークシートおよび進行ルールに基づいて実施されます。',
    point3: '成長型単語帳(Word Pool)を除き、本サービスの機能およびセッションは有料です。'
  },
  
  article3: {
    title: '第3条(利用資格)',
    point1: '※本サービスは教育・学習支援を目的とするものであり、職業斡旋、資格発行、公式試験対策を目的とするものではありません。',
    point2: '利用者は、安定したインターネット環境およびオンライン通話手段を、自らの責任で用意するものとします。',
    point3: '未成年者が本サービスを利用する場合、保護者の事前同意を得たうえで利用するものとし、運営から求められた場合には、同意の有無を確認できる資料を提出するものとします。'
  },
  
  article4: {
    title: '第4条(登録情報およびアカウント管理)',
    point1: '利用者は、正確かつ最新の情報を登録するものとします。',
    point2: '利用者は、自身の登録情報および利用環境について一切の責任を負うものとします。',
    point3: '虚偽情報または不正利用が判明した場合、運営は事前通知なく利用停止または登録抹消を行うことがあります。'
  },
  
  article5: {
    title: '第5条(料金・支払・キャンセル)',
    point1: '本サービスの料金、支払方法、提供形態(単発・回数制・月額等)は、運営が別途定める案内に従うものとします。',
    point2: {
      main: '各セッションの予定日を基準として、3日前より前に、運営指定の方法でキャンセル連絡が到達した場合に限り、キャンセルを受け付けます。',
      sub1: '「3日前」とは、セッション予定日を含まない3日前の日付の23:59まで(日本時間・JST)を指します。',
      sub2: '(例:10日開催の場合、6日23:59まで有効、7日以降の連絡は無効)'
    },
    point3: '回数券制の場合、各セッションについて、予定日の3日前の0:00(JST)に自動的に1回分が消費されます。',
    point4: '自動消費後は、利用者都合による欠席、途中退出、通信環境不備、時差認識違い、体調不良等の理由を含め、返金、振替、補償は一切行いません。',
    point5: '天災地変、法令改正、外部インフラ障害等、運営の合理的支配を超える事由によりサービス提供が不能となった場合の取扱いは、運営が別途定める方法によります。',
    point6: '月額プランの料金は、毎月25日に翌月分を購入する形で課金されます（翌月分の前払い）。',
    point7: '月額プランの解約をご希望の場合は、当月15日までに所定の解約手続きを完了してください。15日までに手続きが完了した場合、翌月分以降の課金は停止されます。16日以降の手続きは翌々月分からの停止となります。'
  },
  
  article6: {
    title: '第6条(禁止事項)',
    intro: '利用者は、以下の行為を行ってはなりません。',
    item1: 'ハラスメント、差別的言動、威圧的行為、暴言',
    item2: '宗教、政治、商業その他営利目的での勧誘行為',
    item3: '教材、ワークシート、コンテンツの無断転載、複製、再配布',
    item4: '他の利用者、運営、または第三者の権利・利益を侵害する行為',
    item5: '本サービスの運営を妨害する行為',
    item6: '法令または公序良俗に反する行為'
  },
  
  article7: {
    title: '第7条(知的財産権)',
    content: '本サービスに関連して提供される教材、文章、デザイン、システム等の知的財産権は、運営または正当な権利者に帰属します。'
  },
  
  article8: {
    title: '第8条(録画・AI・データ利用)',
    point1: '運営は、品質管理、トラブル対応、サービス改善を目的として、必要最小限の範囲でセッション内容を録画、録音、またはテキスト化する場合があります。',
    point2: '前項のデータは、個人を直接特定できない形で統計分析、品質評価、将来の機能改善に利用されることがあります。',
    point3: '当該データは、法令に基づく場合を除き、第三者へ提供または公開されることはありません。'
  },
  
  article9: {
    title: '第9条(免責事項)',
    point1: '本サービスは語学学習および交流の機会を提供するものであり、特定の成果、上達、資格取得等を保証するものではありません。',
    point2: '利用者間または第三者との間で生じたトラブルについて、運営は合理的範囲を超えて責任を負いません。',
    point3: '通信障害、外部サービスの停止、システム不具合等により生じた損害について、運営は責任を負いません。'
  },
  
  article10: {
    title: '第10条(サービスの変更・中断・終了)',
    content: '運営は、必要と判断した場合、事前の通知なく、本サービスの全部または一部を変更、中断、または終了することがあります。'
  },
  
  article11: {
    title: '第11条(規約の変更)',
    point1: '運営は、必要に応じて本規約を改定することができます。',
    point2: '改定後に利用者が本サービスを利用した場合、当該改定に同意したものとみなします。'
  },
  
  article12: {
    title: '第12条(準拠法・管轄)',
    content: '本規約は日本法を準拠法とし、本サービスに関連して生じた紛争については、運営所在地を管轄する裁判所を第一審の専属的合意管轄とします。'
  }
};
